/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppRole = {
    Developer: 'Developer',
    LegalInformationAdmin: 'LegalInformationAdmin',
    GlossaryAdmin: 'GlossaryAdmin',
    UserManagementAdmin: 'UserManagementAdmin',
    ContentManagementAdmin: 'ContentManagementAdmin',
    AppCustomizationAdmin: 'AppCustomizationAdmin',
    ChatbotFeature: 'ChatbotFeature',
    TranscriptionFeature: 'TranscriptionFeature',
    SummarizationFeature: 'SummarizationFeature',
    TranslationFeature: 'TranslationFeature',
    ImageGenerationFeature: 'ImageGenerationFeature',
    SchornBoxFeature: 'SchornBoxFeature',
    TileManagementAdmin: 'TileManagementAdmin'
} as const;
export type AppRole = typeof AppRole[keyof typeof AppRole];


export function instanceOfAppRole(value: any): boolean {
    for (const key in AppRole) {
        if (Object.prototype.hasOwnProperty.call(AppRole, key)) {
            if (AppRole[key as keyof typeof AppRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppRoleFromJSON(json: any): AppRole {
    return AppRoleFromJSONTyped(json, false);
}

export function AppRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppRole {
    return json as AppRole;
}

export function AppRoleToJSON(value?: AppRole | null): any {
    return value as any;
}

export function AppRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): AppRole {
    return value as AppRole;
}

